import { onScopeDispose, ref, watch, type Ref } from 'vue'
import { fetchApplicationKalp, type KalpCalculation } from '@/services/application'

export const useApplicationKalp = (applicationId: Ref<string>) => {
  const kalp = ref<KalpCalculation | null>(null)
  const isKalpLoading = ref(false)
  const kalpError = ref('')
  let loadVersion = 0

  const reloadKalp = async () => {
    const version = ++loadVersion
    const id = applicationId.value
    kalp.value = null
    kalpError.value = ''
    isKalpLoading.value = Boolean(id)
    if (!id) return

    try {
      const response = await fetchApplicationKalp(id)
      if (version === loadVersion && id === applicationId.value) kalp.value = response.maxLoan
    } catch {
      if (version === loadVersion && id === applicationId.value) kalpError.value = 'Kunde inte hämta KALP-beräkningen.'
    } finally {
      if (version === loadVersion && id === applicationId.value) isKalpLoading.value = false
    }
  }

  watch(applicationId, reloadKalp, { immediate: true })
  onScopeDispose(() => {
    ++loadVersion
  })
  return { kalp, isKalpLoading, kalpError, reloadKalp }
}
